import { Component, OnDestroy, OnInit, ViewChild, inject, signal } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { DialogService } from '@next/core-lib/dialog';
import { ExportFormat } from '@next/core-lib/export';
import { ExportOptionsV2 } from '@next/core-lib/table-v2';
import { SelectedCustomer, UserSelectors } from '@next/core-lib/user';
import { Store, select } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';

import { DataSourceService } from '../../../datasource/datasource.service';
import {
  RequestsColumnTypes,
  RequestsOverviewModel,
  requestDisplayColumns,
} from '../../../models/overview.model';
import * as OverviewActions from '../../../store/actions/overview.actions';

@Component({
  selector: 'app-requests-overview-table',
  templateUrl: './requests-overview-table.component.html',
  styleUrls: ['./requests-overview-table.component.scss'],
  providers: [DialogService],
  standalone: false,
})
export class RequestsOverviewTableComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly dataSourceService = inject(DataSourceService);

  readonly dataSource = this.dataSourceService.requestDataSource;
  displayColumns = signal<RequestsColumnTypes[]>([...requestDisplayColumns]);
  selectedCustomer$: Observable<SelectedCustomer> = this.store.pipe(
    select(UserSelectors.selectCustomer),
  );
  readonly destroy$ = new Subject<void>();
  selectedCustomerId = signal<number | undefined>(undefined);
  isGlobalAdministrator = signal(false);
  isCustomer = signal(false);

  exportOptions: ExportOptionsV2 = {
    formats: [
      {
        format: ExportFormat.xlsx,
        name: 'XLSX',
      },
    ],
    fileName: 'mestplace_requests_export_' + new Date().toLocaleDateString(),
  };

  @ViewChild(MatTableDataSource) tableDataSource: MatTableDataSource<RequestsOverviewModel[]>;
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.selectedCustomer$.pipe(takeUntil(this.destroy$)).subscribe((customer) => {
      if (customer) {
        this.selectedCustomerId.set(customer.id);
      }
    });

    this.store
      .select(AuthorizationSelectors.hasGlobalAdministratorRoleForApplicationKey('Mestplace'))
      .pipe(takeUntil(this.destroy$))
      .subscribe((hasGlobalAdministratorRole) => {
        this.isGlobalAdministrator.set(hasGlobalAdministratorRole);
        if (hasGlobalAdministratorRole) {
          this.displayColumns.set([
            RequestsColumnTypes.customerName,
            RequestsColumnTypes.shipToAddress,
            RequestsColumnTypes.contactInformation,
            ...requestDisplayColumns,
          ]);
        }
      });

    this.store
      .select(AuthorizationSelectors.hasCustomerRoleForApplicationKey('Mestplace'))
      .pipe(takeUntil(this.destroy$))
      .subscribe((hasAdvisorRole) => {
        this.isCustomer.set(hasAdvisorRole);
      });
  }
  openRequestOverviewDialog(selectedRequest: RequestsOverviewModel) {
    this.store.dispatch(OverviewActions.openRequestOverviewDialog({ selectedRequest }));
  }
}
